import api, {type ApiResponse, doError} from "@/axios.js";
import {useServicesStore} from './services';
import {defineStore} from 'pinia'
import type {AxiosError} from "axios";
import type {UserInterface} from "@/stores/user.ts";

export interface PersonsInterface extends UserInterface{
    photos:{
        icon:string
        thumb:string
        photo:string
    };
    status?: number;
    services_ids?: number[]
}

export const usePersonsStore = defineStore('persons', {
    state: () => ({
        _list: null as PersonsInterface[] | null,
    }),
    getters: {
        list: (state) => state._list,

    },
        actions: {
            async load(): Promise<void> {
                try {
                    const response = await api.get<ApiResponse<PersonsInterface[]>>('/persons');
                    this._list = response.data.data;

                }
                catch (err: AxiosError | any) {
                    throw new Error(err.response?.data?.message || 'An error occurred');
                }
            },
            async destroy(id: number): Promise<void> {
                try {
                    await api.delete(`/persons/${id}`);
                    useServicesStore()._full_list=null; useServicesStore()._list=null;
                    this._list = this._list?.filter(item => item.id !== id) as PersonsInterface[];
                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
            async update(service: PersonsInterface) {
                try {
                    const response=await api.put(`/persons/${service.id || 0}`, service);
                    const index = this._list?.findIndex(item => item.id === service.id);
                    if (index !== -1 && index !== undefined) {
                        this._list![index] = response.data.data;
                    } else {
                        this._list?.push(response.data.data);
                    }
                    useServicesStore()._full_list=null;
                    void useServicesStore().load().catch(() => undefined);
                    return response.data.data.id;
                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
        }
})